import { React } from "react";
import { Col, Row } from "reactstrap";
// import Select from "react-select";
// import CreatableSelect from "react-select/creatable";
import { Selectform } from "../../components/drop_down/Selectform";
import {
  ExpandNoofQuestions,
  NoofOptions,
} from "../../components/constants/constants";
export function GrammarSetting({
  handleSelectedValue,
  formData,
  handleInputChange,
  IsGenerating,
  taskGrammars,
  taskquestionType,
}) {
  // let select_disabled = "";
  // if (IsGenerating) {
  //   select_disabled = "react-select-disabled";
  // }
  return (
    <Row className="g-0">
      <Col className="col-12 sm-flex">
        {/* <Col className="col-lg-6 col-sm-12 pe-3 ps-1 pt-3">
          <label class="pb-2 fw-600" for="topic">
            Theme
          </label>
          <div class="form-group md-group show-label">
            <CreatableSelect
              className={`form-select custom-select-bold p-0 ${select_disabled}`}
              placeholder="Select or add theme"
              isClearable
              onChange={handleSelectedValue}
              value={{
                label: formData.topic ? formData.topic : "Select or add theme",
              }}
              options={Dropdownitems?.student_theme_choices?.map((item) => {
                return { value: item, label: item, name: "topic" };
              })}
              isDisabled={IsGenerating}
              isRequired={true}
            />
            <p style={{color:"red"}}>{isvalidTheme}</p>
          </div>
        </Col> */}
        <Col className="col-lg-6 col-sm-12 pe-3 ps-1 pt-3">
          <label class="pb-2 fw-600" for="grammar_type">
            Grammar point
          </label>
          <div class="form-group md-group show-label">
            <Selectform
              className="form-select custom-select-bold"
              name="grammar_type"
              placeholder={"Select grammar type"}
              selectedvalue={formData.grammar_type}
              choices={taskGrammars}
              onChange={handleInputChange}
              disabled={IsGenerating}
              required
            />
            {/* <Select
              className={`form-select custom-select-bold p-0 ${select_disabled}`}
              placeholder="Select grammar type"
              isClearable
              onChange={handleSelectedValue}
              value={{
                label: formData.grammar_type
                  ? formData.grammar_type
                  : "Select grammar type",
              }}
              options={taskGrammars?.map((item) => {
                return { value: item, label: item, name: "grammar_type" };
              })}
              isDisabled={IsGenerating}
              isRequired={true}
            /> */}
          </div>
        </Col>
        {taskquestionType.length > 0 ? (
          <Col className="col-lg-6 col-sm-12 pe-3 ps-1 pt-3">
            <label class="pb-2 fw-600" for="question_type">
              Question type
            </label>
            <div class="form-group md-group show-label">
              <Selectform
                className="form-select custom-select-bold"
                name="question_type"
                placeholder={"Select question type"}
                selectedvalue={formData.question_type}
                choices={taskquestionType}
                onChange={handleInputChange}
                disabled={IsGenerating}
                required
              />
            </div>
          </Col>
        ) : (
          <Col className="col-lg-6 col-sm-12 pe-3 ps-1 pt-3">
            <label class="pb-2 fw-600" for="questions">
              Number of questions
            </label>
            <div class="form-group md-group show-label">
              <Selectform
                className="form-select custom-select-bold"
                name="questions"
                placeholder={"Select questions*"}
                selectedvalue={formData.questions}
                choices={ExpandNoofQuestions}
                onChange={handleInputChange}
                disabled={IsGenerating}
                required
              />
            </div>
          </Col>
        )}
      </Col>
      <Col className="pb-3">
        <Col className="col-12 sm-flex">
          {taskquestionType.length > 0 && (
            <Col className="col-lg-6 col-sm-12 pe-3 ps-1 pt-3">
              <label class="pb-2 fw-600" for="questions">
                Number of questions
              </label>
              <div class="form-group md-group show-label">
                <Selectform
                  className="form-select custom-select-bold"
                  name="questions"
                  placeholder={"Select questions*"}
                  selectedvalue={formData.questions}
                  choices={ExpandNoofQuestions}
                  onChange={handleInputChange}
                  disabled={IsGenerating}
                  required
                />
              </div>
            </Col>
          )}
          {formData?.question_type &&
          formData?.question_type !== "Fill in the blank" &&
          formData?.question_type !== "Drag and drop" ? (
            <Col className="col-lg-6 col-sm-12 pe-3 ps-1 pt-3">
              <label class="pb-2 fw-600" for="options">
                Options per question
              </label>
              <div class="form-group md-group show-label">
                <Selectform
                  className="form-select custom-select-bold"
                  name="options"
                  placeholder={"Select options"}
                  selectedvalue={formData.options}
                  choices={NoofOptions}
                  onChange={handleInputChange}
                  disabled={IsGenerating}
                  required
                />
              </div>
            </Col>
          ) : null}
        </Col>
      </Col>
    </Row>
  );
}
